import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdvancedFilterOptionsProvider from '../../../shared/context/advanced-filter-options/advanced-filter-options-context';



interface IProps {

}
function ReportingAndAnalyticsPage({ }: IProps) {



  return (<AdvancedFilterOptionsProvider><Outlet /></AdvancedFilterOptionsProvider>)
}
export default ReportingAndAnalyticsPage;